
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import Axios from 'axios';
import Swal from 'sweetalert2';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
var httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
     })
};
declare var url;
declare var start_host;
@Injectable({
  providedIn: 'root'
})

export class MyserviceService {
  url=url;
  start_host=start_host;
  constructor(private http:HttpClient) { }
  postData(data,type){
    //debugger
    return new Promise((resolve, reject) => {
      Axios.create({
        baseURL: this.url,
        withCredentials: false,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': this.getToken(),
          'database':this.getDatabase()
        }
      }).post(type, JSON.stringify(data)).then(result => {
        if(result.data.code!=undefined){
          if(result.data.code){
            Swal.fire({
              title:  result.data.message,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            }).then((result)=>{
            //  this.getCustomerData();
            })
          }
        }
        resolve(result.data);
      }, err => {
        reject(err);
      });
    })
  }
  private getToken(){
    var token=sessionStorage.getItem('token');
    if(token==undefined){
      return "";
    }else{
      return token;
    }
  }
  public getDatabase(){
    var database="";
    if(sessionStorage.getItem('municipality')!=undefined){
      database=JSON.parse(sessionStorage.getItem('municipality')).municipality_id+'_fee'
    }
    return database;
  }
  get(url){
    var user:any;
    user=sessionStorage.getItem('user');
    if(user){
      user=JSON.parse(user);
      var database="";
      if(sessionStorage.getItem('municipality')!=undefined){
        database=JSON.parse(sessionStorage.getItem('municipality')).municipality_id+'_fee'
      }
      if(user.token){
        httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token':user.token,
              'database':database
             })
        };
      }
    }else{
      var httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
           })
      };
    }
    return new Promise((resolve,reject)=>{
      this.http.get(url,httpOptions).subscribe((result)=>{
        resolve(result);
      },(err)=>{
        reject(err);
      })
    })
  }
  getData(type){
    var user:any;
    user=sessionStorage.getItem('user');
    if(user){
      user=JSON.parse(user);
      if(user.token){
        httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token':user.token
             })
        };
      }
    }else{
      var httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
           })
      };
    }
    return new Promise((resolve,reject)=>{
      this.http.get(this.url+type,httpOptions).subscribe((result)=>{
        resolve(result);
      },(err)=>{
        reject(err);
      })
    })
  }
  checklogin(token){
    // debugger
    sessionStorage.setItem('token',token);
    httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          'x-access-token':token
         })
    };
    return new Promise((resolve,reject)=>{
      this.http.post(this.url+"checkLogin","",httpOptions).subscribe((result)=>{
        resolve(result);
      },(err)=>{
        reject(err);
      })
    })
  }
  getNewToken(token){
    // sessionStorage.setItem('token',token);
    httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          'x-access-token':token
         })
    };
    return new Promise((resolve,reject)=>{
      this.http.post(this.url+"get-new-token","",httpOptions).subscribe((result)=>{
        resolve(result);
      },(err)=>{
        reject(err);
      })
    })
  }
  upload(url,formData){
    return new Promise((resolve,reject)=>{
      Axios.post( this.url+url,
        formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': this.getToken(),
              'database':this.getDatabase()
          }
        }
      ).then((result)=>{
        resolve(result)
      },err=>{
        reject(err)
      })

    })
  }


}

